import { useEffect } from "react";
import { Link } from "react-router-dom";
import { destinations } from "../data/site";
import "./page.css";
import "./home.css";

function Destinations() {
  useEffect(() => {
    document.title = "Destinations · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row mb-4 mb-lg-5">
          <div className="col-lg-8">
            <p className="eyebrow">Destinations</p>
            <h1 className="mb-3">Zanzibar and mainland Tanzania.</h1>
            <p className="page-lead mb-0">
              The island is our focus. Mainland safari days are added when they
              make the trip better, not busier.
            </p>
          </div>
        </div>

        <div className="row g-4 mb-4 mb-lg-5">
          {destinations.map((place) => (
            <div className="col-12 col-md-4" key={place.name}>
              <div
                id={place.name.toLowerCase().replace(/\s+/g, "-")}
                className="place-tile"
              >
                <img src={place.image} alt={place.imageAlt} loading="lazy" />
                <div className="place-tile__copy">
                  <h2 className="h4 mb-1">{place.name}</h2>
                  <p className="mb-0">{place.line}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <Link className="btn btn-mk-gold" to="/contact">
          Plan a trip here
        </Link>
      </div>
    </section>
  );
}

export default Destinations;
